import React from 'react'
import { openNotificationWithIcon } from './notification.helper'
import { Button, Modal, notification } from 'antd'
import { ExclamationCircleOutlined } from '@ant-design/icons'
export const handleErrors = async (callback, setResponseMessage) => {
    try {
        console.log('handleErrors: About to execute callback')
        const result = await callback()
        console.log('handleErrors: Callback executed successfully, result:', result)
        return result
    } catch (error) {
        console.log('handleErrors: Caught error:', error)
        console.log('handleErrors: Error details:', {
            message: error.message,
            status: error.response?.status,
            statusText: error.response?.statusText,
            data: error.response?.data
        })
        
        if (error.response) {
            if (setResponseMessage) {
                setResponseMessage(error.response.data.detail)
            } else {
                if (error.response.data.detail === "Invalid refresh token") return
                openNotificationWithIcon('warning', error.response.data.detail)
            }
        } else {
            console.log('handleErrors: Network or other error:', error)
        }
        
        // Return null to indicate error occurred
        // This way we can distinguish between success and failure
        return null
    }
}
export const throwErrorIfLocked = (locked, unlockAssignment, purpose = 'make changes') => {
    if (locked) {
        const handleUnlockClick = () => {
            notification.destroy()
            Modal.confirm({
                title: 'Confirm unlocking',
                icon: <ExclamationCircleOutlined />,
                okText: 'Unlock',
                onOk() {
                    return unlockAssignment()
                },
                cancelText: 'Cancel',
            })
        }
        notification.warning({
            message: `Please unlock assignment in order to ${purpose}`,
            btn: (
                <Button size='small' onClick={handleUnlockClick}>
                    Unlock
                </Button>
            ),
            duration: 10,
        })
        throw new Error('Please unlock assignment in order to make changes')
    }
}

export const createSearchParams = params => {
    const searchParams = new URLSearchParams()
    Object.entries(params).forEach(([key, value]) => {
        if (value !== null && value !== undefined) {
            if (Array.isArray(value)) {
                value.forEach(v => searchParams.append(key, v))
            } else {
                searchParams.set(key, value)
            }
        }
    })
    return searchParams
}
